import React from 'react';
import styled from 'styled-components';
import Text from 'crehana-ui/Text';

const Container = styled.div<{ bg: string }>`
  background-color: ${props => props.bg || '#06f'};
`;

type TagProps = {
  textLabel: string;
  textColor: string;
  backgroundColor: string;
};

const Tag: React.FC<TagProps> = ({ textLabel, textColor, backgroundColor }) => (
  <Container
    bg={backgroundColor}
    className="w-auto py-4 px-8 flex items-center justify-center flex-grow"
  >
    <Text type="legals" style={{ color: textColor }}>
      {textLabel}
    </Text>
  </Container>
);

export default Tag;
